import React, {useState} from "react";
import InputDateTime from "../components/input/input-datetime.jsx";

const Teste = () => {
    const [date, setDate] = useState()


    return (
        <div className={"bg-white p-4 rounded-md shadow-md m-10"}>
            <InputDateTime
                id="dtStart"
                label="Data inicial *"
                selected={date}
                onChange={(date) => setDate(date)}
                classNameWrapper={"w-full"}
                dateFormat="LL"
            />
        </div>
    );
}

export default Teste;